import type { LINK_TYPE } from 'components/pages/homepage/HeroSlider';

export function createTrackClick(heroTitle?: string) {
  return (linkType: LINK_TYPE, itemNumber: number) => {
    mixpanel.track('homepage_click', {
      current_url: window.location.href,
      title: heroTitle,
      item_number: String(itemNumber),
      link_type: linkType,
      value: ''
    });
  };
}
